import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { Query } from 'react-apollo';
import { path, prop } from 'ramda';
import { GET_USER_SESSION } from './queries';


const userWasVerified = path(['currentUser', 'user_id']);

const withSessionUser = render => (
  <Query
    query={GET_USER_SESSION}
    variables={{ 'cache-buster': Date.now() }}
    notifyOnNetworkStatusChange={false}
    fetchPolicy="cache-and-network"
    context={{ useLocalError: true }}
  >
    {render}
  </Query>
);

const PrivateRoute = ({
  component: Component,
  render,
  LoadingScreen,
  ...rest
}) => (
  <Route
    {...rest}
    render={props => withSessionUser(({ error, loading, data }) => {
      if (error) {
        localStorage.setItem('isExpired', true);
        return (
          <Redirect to={{ pathname: '/', state: { isExpired: true, from: prop('location', props) } }} />
        );
      }

      if (loading) {
        return (
          <LoadingScreen />
        );
      }

      if (!userWasVerified(data)) {
        return (
          <Redirect to={{ pathname: '/', state: { from: prop('location', props) } }} />
        );
      }

      if (render) {
        return render({
          user: prop('currentUser', data),
          ...props,
        });
      }

      return (
        <Component user={prop('currentUser', data)} {...props} />
      );
    })}
  />
);

PrivateRoute.defaultProps = {
  LoadingScreen: () => <p>Loading...</p>,
};

export default PrivateRoute;
